<template>
<el-container id="home-main">
  <div>
    <publicHeader @hotelLanguage="hotelLanguage"></publicHeader>
    <div class="bodyMain">
      <div class="icon" v-if="order.payment_second_confirm !== 1">
        <img :src="['0', '2'].includes(order.payment_second_confirm) ? '/static/img/paymentSecondSuccess.png' : '/static/img/paymentSecondFail.png'" />
        <div class="iconText fail" v-if="order.payment_second_confirm === '1'">{{ $t('ConfirmIng') }}</div>
        <div class="iconText" v-else-if="['0', '2'].includes(order.payment_second_confirm)">{{ $t('paymentConfirmSuccess') }}</div>
        <div class="iconText fail" v-else>{{ $t('paymentConfirmFail') }}</div>
      </div>
      <div class="content">
        <div class="contentRow">
          <span class="contentRowTitle">{{$t('BookingId')}}：</span>
          <span class="contentRowText">{{order.orderno}}</span>
        </div>
        <div class="contentRow">
          <span class="contentRowTitle">{{$t('hotelName')}}：</span>
          <span class="contentRowText" v-if="language === 'zh' && order.hotelname_zh !== ''">{{order.hotelname_zh}}</span>
          <span class="contentRowText" v-else>{{order.hotelname_en}}</span>
        </div>
        <div class="contentRow">
          <span class="contentRowTitle">{{$t('guestName')}}：</span>
          <span class="contentRowText">{{order.guest_name}}</span>
        </div>
        <div class="contentRow">
          <span class="contentRowTitle">{{$t('checkInDate')}}：</span>
          <span class="contentRowText">{{order.checkin}}</span>
        </div>
        <div class="contentRow">
          <span class="contentRowTitle">{{$t('checkOutDate')}}：</span>
          <span class="contentRowText">{{order.checkout}}</span>
        </div>
        <div class="contentRow">
          <span class="contentRowTitle">{{$t('totalPaymentAmount')}}：</span>
          <span class="contentRowText">{{ order.totalprice }} {{ order.currency }}</span>
        </div>
        <div class="contentRow">
          <span class="contentRowTitle">{{$t('payMethod')}}：</span>
          <span class="contentRowText">{{ order.pay_way }}</span>
        </div>
      </div>
      <div style="width: 100%">&nbsp;</div>
      <div class="notice">
        <span v-if="['0', '2'].includes(order.payment_second_confirm)">
          {{ $t('paymentConfirmSuccessNotice')}}{{order.guest_email}}{{$t('paymentConfirmSuccessNoticeTwo')}}
          <!-- <a :href="this.contactUsUrl"  style="color:#5392F9; cursor: pointer;">{{$t('contactUs')}}</a> -->
          <router-link :to="contactUsUrl" style="color:#5392F9; cursor: pointer;">
            {{$t('contactUs')}}
          </router-link>
        </span>
        <span v-else-if="['3', '4'].includes(order.payment_second_confirm)">
          {{$t('paymentConfirmFailNotice')}}
          <!-- <a :href="this.contactUsUrl" style="color:#5392F9; cursor: pointer;">{{$t('contactUs')}}</a> -->
          <router-link :to="contactUsUrl" style="color:#5392F9; cursor: pointer;">
            {{$t('contactUs')}}
          </router-link>
        </span>
      </div>
    </div>
  </div>
  <publicFooter :languageSet="language"></publicFooter>
</el-container>
</template>

<script scoped>
import { confirmResult } from '@/request/order.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
export default {
  name: 'Home',
  components: {
    publicFooter,
    publicHeader,
    confirmResult
  },
  props: [],
  data () {
    return {
      language: this.common.languageSet(this),
      currency: this.common.currencySet(this),
      order: {payment_second_confirm: 1, orderno: '', hotelname_zh: '', hotelname_en: '', guest_name: '', checkin: '', checkout: '', totalprice: '', currency: '', pay_way: ''},
      contactUsUrl: ''
    }
  },
  created: function () {
    this.confirmResultShow()
  },
  mounted: function () {},
  watch: {},
  beforeDestroy () {},
  methods: {
    confirmResultShow: function () {
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      let orderno = this.common.linkQuerys.orderno ? this.common.linkQuerys.orderno : ''
      let action = this.common.linkQuerys.action ? this.common.linkQuerys.action : ''

      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      // 订单结果数据
      var confirmResultJson = {
        'token': token,
        'orderno': orderno,
        'action': action,
        'time': time,
        'operation': 'paymentSecondConfirmation'
      }
      var confirmResultString = this.common.encryptionData(confirmResultJson, this)
      confirmResult(confirmResultString).then(res => {
        if (['200'].includes(res.flag)) {
          this.order = res.data
          // this.contactUsUrl = '/question/contactUs?orderno=' + this.order.orderno
          var newQuerys = this.common.linkEncode({'orderno': this.order.orderno}, 'obj')
          this.contactUsUrl = {name: 'contactUs', params: {'querys': newQuerys}}
        } else {
          alert(res.msg)
        }
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(confirmResultJson, res, requestTime, responseTime)
        })
      })
    },
    hotelLanguage (language) {
      this.language = language
    }
  }
}
</script>
<style type="text/css" scoped>
 .bodyMain {
   width: 100%;
   height: 50vh;
   text-align: center;
   line-height: 25px;
   font-size: 18px;
   align-items:center;
   justify-content:center;
   font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
   font-weight: 400;
   margin-top: 100px;
   margin-bottom: 15vh;
 }
 .icon {
   display: flex;
   margin-bottom: 30px;
   justify-content: center;
   align-items: center;
 }
 .icon img {
   height: 50px;
   display: inline-block;
   text-align: center;
   line-height: normal;
   text-transform: none;
   margin-right:8px;
 }
 .iconText {
   background: inherit;
   background-color: rgba(255, 255, 255, 0);
   border: none;
   border-radius: 0px;
   -moz-box-shadow: none;
   -webkit-box-shadow: none;
   box-shadow: none;
   font-weight: 600;
   font-style: normal;
   font-size: 18px;
   color: #00B870;
   display: inline-block;
 }
 .fail {
   color: rgb(236, 128, 141) !important;
 }

 .content {
   display: inline-block;
   font-style: normal;
   font-size: 14px;
   letter-spacing: 1px;
   color: #4F4C4C;
   line-height: 30px;
   margin-bottom: 30px;
   text-align: left;
 }

 .content .contentRow {
   width: 100%;
 }

 .content .contentRow .contentRowTitle {
   font-weight: 600;
 }

 .contentRow .contentRow .contentRowText {
   font-weight: 400;
 }

 .notice {
   display: inline-block;
   width: 60%;
   line-height: 19px;
   font-size: 12px;
   font-weight: 400;
   color:#4F4C4C;
 }

 @media only screen and (max-width:1099px){
   .bodyMain {
     width: 96%;
     height: 50vh;
     text-align: center;
     margin: 100px auto;
     line-height: 17px;
     font-size: 14px;
     align-items:center;
     justify-content:center;
     font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
     font-weight: 400;
   }
   .notice {
     display: inline-block;
     width: 90%;
     line-height: 19px;
     font-size: 12px;
     font-weight: 400;
     color:#4F4C4C;
   }
 }
</style>



// WEBPACK FOOTER //
// src/components/order/PaymentSecondConfirm.vue